.mainScreen {
  color: #FFFBF1;
  position: relative;

  img {
    width: 100%;
  }
}

.title {
  text-align: center;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  padding: 0 20px;
  margin-bottom: -30px;
}

// Dark mode
:global body.dark {
  :local {

    .mainScreen {
      display: flex;
      flex-direction: column;
    }

    .title {
      z-index: 1;
    }

    // img {
    //   z-index: 0;
    // }

  }
}
